(() => {
  if (!document.body?.classList.contains('template-product')) return;

  const excludedTags = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA']);
  const textAttributes = ['aria-label', 'aria-description', 'alt', 'title', 'placeholder'];
  const excludedSelector = 'script, style, noscript, textarea, template';

  function removeJsonMarkers(value) {
    return value
      .replace(/\[\\"/g, '')
      .replace(/\\"\]/g, '')
      .replace(/\["/g, '')
      .replace(/"\]/g, '');
  }

  function sanitizeText(node) {
    const current = node.nodeValue;
    if (current && (current.includes('["') || current.includes('"]') || current.includes('[\\"') || current.includes('\\"]'))) {
      const cleaned = removeJsonMarkers(current);
      if (cleaned !== current) node.nodeValue = cleaned;
    }
  }

  function sanitizeAttributes(element) {
    for (const name of textAttributes) {
      if (!element.hasAttribute(name)) continue;
      const current = element.getAttribute(name);
      if (!current) continue;
      const cleaned = removeJsonMarkers(current);
      if (cleaned !== current) element.setAttribute(name, cleaned);
    }
  }

  function sanitizeSubtree(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      if (!root.parentElement?.closest(excludedSelector)) sanitizeText(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE || root.matches(excludedSelector)) return;

    sanitizeAttributes(root);
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          if (node.nodeType === Node.ELEMENT_NODE && excludedTags.has(node.tagName)) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === Node.TEXT_NODE) sanitizeText(node);
      else sanitizeAttributes(node);
    }
  }

  sanitizeSubtree(document.body);

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'characterData') {
        sanitizeText(record.target);
      } else if (record.type === 'attributes') {
        sanitizeAttributes(record.target);
      } else {
        for (const addedNode of record.addedNodes) sanitizeSubtree(addedNode);
      }
    }
  });

  observer.observe(document.body, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: textAttributes
  });
})();
